import { Drawer, Flex, Box, Button } from '@mantine/core';
import { FormInput } from '../../../../components/FormElements/FormInput';
import { useForm } from 'react-hook-form';
import { TbChevronRight } from 'react-icons/tb';
import { useCreateGroup, useUpdateGroupedWorkflow } from '../../../../services/workflow.services';
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

/**
 * @param {{
 *   isOpen?: any;
 *   defaultValues?: any;
 *   isEdit?: boolean;
 *   onClose?: any;
 *   workflowIds?: any;
 *   refetch?: any;
 *   onClearGroup?: any;
 *   groupId?: any;
 * }} props
 */
export function MergeAIFM({
  isOpen,
  defaultValues,
  isEdit = false,
  onClose,
  workflowIds,
  refetch,
  onClearGroup,
  groupId
}) {
  const { control, handleSubmit, reset } = useForm();
  const navigate = useNavigate();
  const createGroup = useCreateGroup();

  const updateGroupedWorkflows = useUpdateGroupedWorkflow();

  useEffect(() => {
    if (isEdit && isOpen) {
      reset({
        ...defaultValues
      });
    }
  }, [isOpen]);

  const onSubmit = data => {
    if (isEdit) {
      updateGroupedWorkflows.mutate(
        {
          id: groupId,
          body: {
            ...data
          }
        },
        {
          onSuccess: () => {
            refetch();
            onClose();
          },
          onError: res => {
            toast.error(res?.data?.detail);
          }
        }
      );
    } else {
      createGroup.mutate(
        {
          name: data.name,
          workflow_ids: workflowIds
        },
        {
          onSuccess: res => {
            navigate(`/project/quaters/${res.id}?type=grouped`);
            onClose();
            refetch();
            onClearGroup();
          },
          onError: res => {
            toast.error(res?.data?.detail);
          }
        }
      );
    }
  };

  return (
    <Drawer
      w="400px"
      title={isEdit ? 'Edit Merged AIFM' : 'Create Merged AIFM'}
      withContainer={false}
      opened={isOpen}
      onClose={onClose}
      position="right"
      overlayProps={{
        display: 'none'
      }}
    >
      <Box pt="16px" component="form" onSubmit={handleSubmit(onSubmit)}>
        <FormInput name="name" control={control} label="Merged AIFM Name" required />
        <Flex mt="48px" justify="flex-end" className="footer">
          <Button
            loading={createGroup.isLoading || updateGroupedWorkflows.isLoading}
            rightSection={<TbChevronRight />}
            size="sm"
            type="submit"
          >
            Continue
          </Button>
        </Flex>
      </Box>
    </Drawer>
  );
}
